import { jsx } from "panel";
import X from "../icons/x.svg";
export function template() {
  const {
    hidden
  } = this.state;
  const mp23Brand = true;
  return /* @__PURE__ */ jsx("div", { sel: ".gdpr-banner-container", class: {
    hidden,
    "mp23-brand": mp23Brand
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, mp23Brand ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".gdpr-banner-content" }, /* @__PURE__ */ jsx("div", null, "Mixpanel uses cookies to run our site and improve its functionalities for a better browsing experience. To learn more about Mixpanel's use of cookies please review our ", /* @__PURE__ */ jsx("a", { attrs: {
    href: `https://mixpanel.com/legal/privacy-policy`
  } }, "Privacy Policy"), "."), /* @__PURE__ */ jsx("div", { sel: ".gdpr-banner-buttons" }, /* @__PURE__ */ jsx("button", { sel: ".button.gdpr-banner-accept-button", on: {
    click: this.helpers.onAccept
  } }, "Accept"), /* @__PURE__ */ jsx("button", { sel: ".button.gdpr-banner-dismiss-button", on: {
    click: this.helpers.onDismiss
  } }, "Decline"))), /* @__PURE__ */ jsx("button", { sel: ".gdpr-banner-dismiss", on: {
    click: this.helpers.onDismiss
  } }, /* @__PURE__ */ jsx("img", { attrs: {
    src: X
  }, sel: ".svg-icon" }))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".gdpr-banner-text" }, `Mixpanel uses cookies to make it easier for you to use our website; read more about our `, /* @__PURE__ */ jsx("a", { attrs: {
    href: `https://mixpanel.com/legal/privacy-policy`
  } }, "cookie policy"), `. We will also collect personal information about you as described in our `, /* @__PURE__ */ jsx("a", { attrs: {
    href: `https://mixpanel.com/legal/privacy-policy`
  } }, "privacy statement"), `. By using our services you agree to the use of cookies and to the collection of your personal information.`), /* @__PURE__ */ jsx("button", { sel: ".gdpr-banner-accept", on: {
    click: this.helpers.onAccept
  } }, "Accept"), /* @__PURE__ */ jsx("button", { sel: ".gdpr-banner-accept", on: {
    click: this.helpers.onDismiss
  } }, "Reject"), /* @__PURE__ */ jsx("button", { sel: ".gdpr-banner-dismiss", on: {
    click: this.helpers.onDismiss
  } }, /* @__PURE__ */ jsx("img", { attrs: {
    src: X
  }, sel: ".svg-icon" }))));
}
